// Wrapper fino sobre las Cloud Functions de dealers (Postgres/Neon).
// Primera pieza de la capa de acceso a datos que hoy no existe en el
// resto de la app — ver plan de migración, Fase 3.
import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();
const listarDealersFn = httpsCallable(functions, 'listarDealers');
const crearDealerFn = httpsCallable(functions, 'crearDealer');
const actualizarDealerFn = httpsCallable(functions, 'actualizarDealer');
const eliminarDealerFn = httpsCallable(functions, 'eliminarDealer');

export async function listarDealers() {
  const result = await listarDealersFn();
  return result.data.dealers;
}

export async function crearDealer(datos) {
  const result = await crearDealerFn(datos);
  return result.data.dealer;
}

export async function actualizarDealer(id, datos) {
  const result = await actualizarDealerFn({ id, ...datos });
  return result.data.dealer;
}

export async function eliminarDealer(id) {
  await eliminarDealerFn({ id });
}
